import SummaryWishes from './Wishes'

export default SummaryWishes
